import axios, { AxiosPromise } from 'axios';

export default class ChallengeService {
  public static getCompanyChallenges(): AxiosPromise {
    return axios.get('http://localhost/api/employee/company/challenges');
  }
}
